var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModifica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "1F1F1F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86 13.4C84.2 11.8 82 10.9 79.7 10.9C77.1 10.9 74.6 12 72.9 13.9L37.4 52.7C37.1 53 36.9 53.3 36.8 53.7L32.6 66.2C32.2 67.4 32.4 68.8 33.2 69.8C34 70.9 35.2 71.5 36.5 71.5C37.1 71.5 37.6 71.4 38.1 71.2L50.2 65.9C50.6 65.7 50.9 65.5 51.1 65.2L86.6 26.4C90 22.7 89.7 16.8 86 13.4ZM47.4 61.1L38.7 64.9L41.7 55.9L42.5 55L48.2 60.2L47.4 61.1ZM82.5 22.7L51.9 56.3L46.2 51.1L76.8 17.6C77.5 16.8 78.5 16.4 79.6 16.4C80.5 16.4 81.4 16.8 82.1 17.4L82.2 17.5C82.9 18.2 83.4 19.1 83.4 20.1C83.5 21 83.2 22 82.5 22.7Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 42.5C78 42.5 76.8 43.7001 76.8 45.2001V74.3001C76.8 79.5001 72.6 83.7 67.4 83.7H25.9C20.7 83.7 16.5 79.5001 16.5 74.3001V33.1C16.5 27.9 20.7 23.7001 25.9 23.7001H55.9C57.4 23.7001 58.6 22.5 58.6 21C58.6 19.5 57.4 18.3 55.9 18.3H25.9C17.7 18.3 11 25.0001 11 33.2001V74.4001C11 82.6001 17.7 89.3 25.9 89.3H67.4C75.6 89.3 82.3 82.6001 82.3 74.4001V45.2001C82.3 44.5 82 43.8 81.5 43.3C81 42.8 80.3 42.5 79.5 42.5Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifica);
export default __webpack_public_path__ + "static/media/modifica.0118ca622c9d6de99431f2e039d99a34.svg";
export { ForwardRef as ReactComponent };